<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Introduction"><div class="titlepage"><div><div><h2 style="color : #7b3800; size: 2em;"><a id="d0e79" xmlns:saxon="http://icl.com/saxon"></a>Introduction
        </h2></div></div></div><p>Have you ever perused a restaurant menu and been far more tempted
        by the appetizer offerings than the entrées? I know I have. Perhaps it’s because the
        starters often feature tantalizing ingredients, intriguing preparations, and manageable
        portion sizes. Or maybe it’s because appetizers are synonymous with parties, and party food
        is meant to be fun. </p><p>When I entertain at home, I love to prepare hors d’oeuvres. After
        all, appetizers are meant to be shared with others. For me, a few platters of lovingly
        prepared canapés mark the joy of gathering with friends and family over good food and drink.
        </p><p>I especially love small appetizers that combine creativity and great flavor in just a
        bite or two. The best hors d’oeuvres are pleasing to both the palate and the eye, conveying
        to your guests that you made a special effort to create a festive start to your gathering.
        The recipes in this collection each have elements that can be prepared in advance, so you
        can enjoy your own party instead of being stuck in the kitchen doing prep work. </p><p>The
        book is divided into four sections. A selection of basic recipes will guide you in preparing
        miniature rolls, crisps, and crostini, so you can build your own tasty creations from the
        bottom up. Finger foods are small, unfussy bites that can be eaten out of hand—like tiny
        artichoke-sausage pizzas drizzled with a balsamic glaze, or miniature Mexican tostadas
        served in crispy corn shells. Skewered appetizers layer a variety of flavors like sweet
        dried apricots stuffed with tangy chèvre and wrapped in bacon, or delicate fried artichoke
        hearts dipped in a lemony garlic butter. Mini sandwiches feature a variety of breads and
        fillings, from baby open-faced Reubens served with homemade Thousand Island dressing to a
        miniature version of the famous lobster roll. </p><p>When you’re entertaining, I recommend
        choosing a pleasing selection of appetizers that vary in presentation, texture, color,
        temperature, and flavor. For example, you could serve a tray of hot, crispy <span class="link" href="#/ch03#nacho" id="d0e92" title="Link target outside of Sample">Crab and Avocado
          Nachos,</span> a platter of colorful <span class="link" href="#/ch04#greek" id="d0e95" title="Link target outside of Sample">Greek Salad on a Stick skewers,</span> and a plate of elegant
          <span class="link" href="#/ch05#fig" id="d0e98" title="Link target outside of Sample">Prosciutto, Pear, Fig, and Brie Toasts.</span>
        Arrange hors d’oeuvres neatly on platters, and let the food take center stage by leaving
        plates unadorned or choosing simple garnishes. </p><p>After trying the small bites featured
        in this book, you may decide to forgo the entrée at your next dinner party in favor of an
        assortment of tantalizing appetizers. Whether you’re entertaining a small group or a large
        crowd, small bites offer a variety of flavors with something to please everyone. Let’s start
        cooking and get the party started!</p><div class="mediaobject" title="Photo of spread."><img alt="Photo of spread." src="images/CoverComposite-1957.jpg"/></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?136d0192